import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from "react-router-dom";
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Menu, Popup } from 'semantic-ui-react';

import CreateStory from 'app/components/CreateStory';
import SelfieUpload from 'shared/components/SelfieUpload';
import NewPhotos from 'shared/components/NewPhotos';
import MomentContainer from 'app/screens/MomentContainer';
import Loading from 'shared/components/Loading';
import Nav from 'shared/components/Nav';
import { WebSocketContext } from 'shared/components/WebSocket';
import SelectionHeader from 'shared/components/SelectionHeader';
import ActionSheetBackdrop from 'shared/components/ActionSheetBackdrop';
import ProfilePage from 'shared/components/ProfilePage';
import QrCode from 'shared/components/QrCode';
import Receipt from 'shared/components/Receipt';
import CustomLoading from 'shared/components/CustomLoading/CustomLoading';
import MarketingPopup from 'shared/components/MarketingPopup';


import config from 'shared/config/config';
import { THEME_HEADER_URL } from 'shared/utils/Constants';
import { print } from 'shared/utils/Helpers';

import {
  fetchStories,
  loadStories,
  loadPremiumStories,
  addStoryMoments,
  getMarketingByJobId,
  showMarketing
} from 'shared/actions/storyActions';

import {
  addPhotoSwipeItems
} from 'shared/actions/photoSwipeActions';

import {
  SHOW_PROFILE,
  SHOW_RECEIPT,
  SHOW_STORY,
  SHOW_SELFIE_UPLOAD
} from 'shared/actions/types';

import {
  showLoading
} from 'shared/actions/homeActions'

import {
  hideNavBar
} from 'shared/actions/navActions';

import {
  me,
  logout,
  getAccessCode
} from 'shared/actions/userActions';

import {
  onAccountMessage,
  onUserMessage
} from 'shared/services/Pusher';

import {
  trackEvent
} from 'shared/services/Analytics';

import {
  resetMetaTags
} from 'shared/services/MetaTags';

import {
  logPWAError
} from 'shared/services/LogService';

import UserService from 'shared/services/UserService';

let userService = new UserService();

const isMobile = window.innerWidth <= 768;

const showToolbar = false;

const styles = theme => ({
  root: {
    display: 'flex',
    background: config.pwa_stories_bg,
  },
  content: {
    flex: 1,
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '5rem',
    marginLeft: isMobile || config.mobile_cart ? '5px' : 'calc(20vw + 17px)',
    width: isMobile || config.mobile_cart ? '100%' : '80vw',
    float: isMobile || config.mobile_cart ? 'right' : 'none',
    height: '100%',
    background: config.pwa_stories_bg,
    top: '1em',
    bottom: 0
  },
  spacer: {
    position: 'relative',
    zIndex: 0,
    height: showToolbar ? 'calc(3.7rem + 21vh)' : '21vh'
  },
  cover: {
    position: 'absolute',
    top: showToolbar ? '3.7rem' : 0,
    left: 0,
    width: '100%',
    height: '21vh',
    overflow: 'hidden'
  },
  toolbar: theme.mixins.toolbar,
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  updateButton: {
    marginRight: 20,
    alignSelf: "flex-end"
  },
  drawerPaper: {
    width: '80vw',
    overflow: 'visible !important',
    display: 'none !important'
  },
  paper: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  closeBtn: {
    position: 'fixed',
    top: '5px',
    right: '-3.5rem',
    fontSize: '3rem',
    color: '#fff',
    cursor: 'pointer',
    background: '#222',
    padding: '5px',
    borderRadius: '5px'
  },
  listItem: {
    marginRight: '0 !important'
  },
  listIcon: {
    fontSize: '2rem !important'
  },
  listText: {
    padding: '0 !important'
  },
  navBar: {
    background: config.pwa_navbar_bg_color + " !important",
  },
  user: {
    color: config.pwa_navbar_font_color + " !important"
  }
});

class Home extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      openCreateStoryDialog: false,
      loggedIn: false,
      loading: true,
      openProfilePage: false,
      openQrCode: false,
      showSelfieUpload: false,
      showNewPhotos: false,
    };
  }

  componentDidMount() {

    resetMetaTags();
    this.getSession();

  }

  shouldComponentUpdate(newProps, newState) {
    return this.state.loggedIn !== newState.loggedIn ||
      this.state.loading !== newState.loading ||
      this.state.error !== newState.error || newProps.home !== this.props.home ||
      this.props.stories !== newProps.stories ||
      this.state.showSelfieUpload !== newState.showSelfieUpload ||
      this.state.showNewPhotos !== newState.showNewPhotos
  }

  componentDidCatch(error, info) {
    logPWAError(error, info);

    // this will ultimately refresh to the stories screen
    this.setState({ loggedIn: false });
  }

  addToStory(storyId, moment) {
    const { addStoryMoments, addPhotoSwipeItems } = this.props;

    addStoryMoments(storyId, [moment]);

    let psItem = {
      id: moment.id,
      position: moment.position,
      src: moment.print_url || moment.preview_url,
      shareUrl: moment.print_url || moment.preview_url,
      fallbackShareUrl: moment.share_url,
      filename: moment.id.toString(),
      mimeType: moment.type || 'image/jpeg',
      w: moment.width,
      h: moment.height,
      printStoreAccessible: !moment.cutout && moment.type != 'image/gif'
    }

    addPhotoSwipeItems(storyId, [psItem])
  }

  onMomentAvailable(moment) {
    const { stories } = this.props;

    // TODO: Skipping premium moments for now since
    // - This currently only applies to embedded apps
    // - Cart Items are always pulled fresh when you click a gallery
    if (moment && moment.premium && !moment.purchased) {
      return
    }

    if (moment && moment.story_ids) {
      for (let story of stories) {
        if (moment.story_ids.includes(story.id)) {
          this.addToStory(story.id, moment);
          break
        }
      }
    } else if (moment && moment.job_id) {
      for (let story of stories) {
        if (story.job_id === moment.job_id) {
          this.addToStory(story.id, moment);
          break
        }
      }
    }
  }

  onNewPhotosAvailable() {
    this.setState({ showNewPhotos: true });
  }

  async getSession() {
    let user = this.props.user || await this.props.me();

    if (user) {

      // Listening for moments if embedded user
      if (user.theme && user.theme.id) {
        onAccountMessage(user.account_id, "moment", "available", msg => this.onMomentAvailable(msg.moment));
      }

      // Listening for new moments from selfie upload
      if (this.props.match && this.props.match.url.includes("selfie")) {
        onUserMessage(user.id, "selfie", "available", msg => this.onNewPhotosAvailable());
      }

      trackEvent('App.Open', {
        userId: user.id
      });

      this.maybeGetStories()
        .then(() => {
          this.setState({
            email: user.email,
            name: user.name,
            loggedIn: true,
            loading: false
          });

          if (this.props.match && this.props.match.url.includes("selfie")) {
            this.setState({ showSelfieUpload: true });
          } else {
            this.getMarketing();
          }

        });
    } else {
      this.setState({
        loggedIn: false,
        loading: false
      });
    }
  }

  maybeGetStories() {
    if (this.props.stories.length) {
      return Promise.resolve();
    } else {
      return this.props.fetchStories();
    }
  }


  async getMarketing() {
    const { getMarketingByJobId, stories, premiumStories, user } = this.props;

    let allStories = stories.concat(premiumStories);
    if (allStories) {

      allStories.sort((story1, story2) => {
        if (story1.id < story2.id) {
          return 1;
        } else {
          return -1;
        }
      });

      for (let story of allStories) {
        let marketingShown = localStorage.getItem(`marketing_popup_shown_${story.id}`) ?? false;
        if (marketingShown) {
          break;
        }

        let marketing = await getMarketingByJobId(story.job_id);
        if (marketing) {
          this.props.showMarketing(true);
          localStorage.setItem(`marketing_popup_shown_${story.id}`, true);
          break;
        }
      }
    }
  }

  closeMarketing() {
    this.props.showMarketing(false);
    this.setState({ showCartDetailsModal: false });
    window.currentModal && window.currentModal.close();
    document.body.style.overflowY = 'scroll';
  }

  async handleLogout() {
    print("user to logout: ", userService.getUser());
    this.props.showLoading(true);

    userService.logout().then((resp) => {
      this.props.showLoading(false);
      window.location = "/login";
    })

    this.props.logout()
      .then(() => {
        this.setState({
          loggedIn: false
        });
      });
  }

  closeQRCodeModal() {
    if (this.state.openQrCode) {
      this.setState({ openQrCode: false });
      window.currentModal.close();
      document.body.style.overflowY = 'scroll';
    }
  }

  closeSelfieUpload() {
    if (this.state.showSelfieUpload) {
      this.setState({ showSelfieUpload: false });
      window.currentModal.close();
      document.body.style.overflowY = 'scroll';
    }
  }

  closeNewPhotos() {
    if (this.state.showNewPhotos) {
      this.setState({ showNewPhotos: false });
      window.currentModal.close();
      document.body.style.overflowY = 'scroll';
    }
  }

  renderStories = (storyId) => {
    return (
      <MomentContainer stories={this.props.stories}
        premiumStories={this.props.premiumStories}
        onAdd={this.openAddStoryDialog}
        deeplinkStoryId={storyId} />
    )
  }

  renderProfile = (showInfo) => {
    return <ProfilePage showInfo={showInfo} onClickLogout={this.handleLogout.bind(this)} userName={this.state.name} />
  }

  renderReceipt = (storyId, purchase) => {
    return <Receipt purchase={purchase} storyId={storyId} />
  }

  getTopBarLogo() {
    const { user } = this.props;
    let locale = 'en-us';
    if (user) {
      locale = user.locale
    }

    if (locale && locale.includes("de")) {
      return config.pwa_navbar_desktop_brand_logo_german;
    } else {
      return config.pwa_navbar_desktop_brand_logo;
    }
  }

  renderHeader() {
    const { classes, user } = this.props;

    let qr_code = null;
    let terms = null;
    let privacy = null;

    let coverImageStyle = {
      maxHeight: '100%',
      maxWidth: '100%',
      width: 'auto',
      height: 'auto',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
    };

    if (user) {
      if (user.theme.show_qr) {
        qr_code = (
          <Menu.Item name='qrcode' onClick={() => {
            this.props.getAccessCode();
            this.setState({ openQrCode: true });
          }}>
            <Icon name='qrcode' />
          </Menu.Item>
        )
      }
      if (user.theme.terms_url) {
        terms = (
          <Menu.Item>
            <a href={user.theme.terms_url} style={{ color: 'black' }}><Icon name='file alternate outline' /></a>
          </Menu.Item>
        )
      }
      if (user.theme.privacy_url) {
        privacy = (
          <Menu.Item>
            <a href={user.theme.privacy_url} style={{ color: 'black' }}><Icon name='privacy' /></a>
          </Menu.Item>
        )
      }
      if (user.theme.stretch_header) {
        coverImageStyle = {
          width: '100%',
          height: 'auto',
          position: 'relative'
        }
      }
    }

    return (
      <div>
        <div className={classes.spacer} />
        <div className={classes.cover}>
          <img style={coverImageStyle} src={THEME_HEADER_URL(user.theme.id)} />
        </div>
        <div>
          <Menu>
            <Menu.Menu secondary position='right'>
              {qr_code}
              {terms}
              {privacy}
            </Menu.Menu>
          </Menu>
        </div>
      </div>
    )
  }

  renderMobileCartHeader(classes) {

    let logoStyle = null;
    if (config.customer == 'hpx') {
      logoStyle = isMobile ? { 'width': '15em' } : { 'width': '20em' }
    }

    return (
      <Menu inverted={config.customer === 'hpx'} size='large' fixed='top'>
        <Menu.Item>
          <img alt="logo" src={this.getTopBarLogo()} style={logoStyle} />
        </Menu.Item>
        <Menu.Menu position='right'>
          {
            isMobile ?
              <Popup className={classes.user} inverted={config.customer === 'hpx'} trigger={
                <Menu.Item className={classes.user}>
                  <Icon name='user' />
                </Menu.Item>} content={this.props.user.email} />
              :
              <Menu.Item className={classes.user}>
                <Icon name='user' />
                {this.props.user.email}
              </Menu.Item>
          }
        </Menu.Menu>
      </Menu>
    )
  }

  render() {

    if (this.state.loading || this.props.home.isLoading) {
      return (
        <CustomLoading />
      );
    }

    if (!this.state.loggedIn) {
      return (<Redirect to="/login" />);
    }

    const { classes, theme, match, receipt, home, user } = this.props;

    let storyId = match.params.id || match.params.story_id;
    let page;

    switch (home.state) {
      case SHOW_STORY:
        page = this.renderStories(storyId);
        break;
      case SHOW_PROFILE:
        page = this.renderProfile(false);
        break;
      case SHOW_RECEIPT:
        page = this.renderReceipt(storyId, receipt.purchase);
        break;
    }

    let nav = (<Nav />);
    if (config.mobile_cart) {
      nav = null;
    }

    let header = null;
    let contentStyle = {};
    if (user && user.theme.hide_nav) {
      nav = null;
      header = this.renderHeader();
      contentStyle = {
        paddingLeft: '0px',
        paddingRight: '0px',
        marginLeft: '0px',
      }
    }

    return (
      <div className={classes.root}>
        {config.mobile_cart && this.renderMobileCartHeader(classes)}
        <CssBaseline />
        <main className={classes.content} style={contentStyle}>
          <div className={classes.toolbar}>
            {header}
          </div>
          <div>
            {page}
          </div>
        </main>
        {nav}
        <SelectionHeader />
        <ActionSheetBackdrop />
        <QrCode qrDialogOpen={this.state.openQrCode} closeQRCodeModal={this.closeQRCodeModal.bind(this)} />
        <MarketingPopup open={this.props.showMarketingPopup} onClose={this.closeMarketing.bind(this)} />
        <SelfieUpload open={this.state.showSelfieUpload} onClose={this.closeSelfieUpload.bind(this)} storyId={storyId} loggedIn={this.state.loggedIn}/>
        <NewPhotos open={this.state.showNewPhotos} onClose={this.closeNewPhotos.bind(this)} storyId={storyId} />
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

Home.contextType = WebSocketContext;

const mapStateToProps = state => ({
  home: state.homeReducer.home,
  receipt: state.homeReducer.receipt,
  user: state.userReducer.user,
  stories: loadStories(state),
  premiumStories: loadPremiumStories(state),
  selectedMarketing: state.storyReducer.selectedMarketing,
  showMarketingPopup: state.storyReducer.showMarketing
});

export default connect(mapStateToProps, { showLoading, hideNavBar, me, logout, getAccessCode, fetchStories, addStoryMoments, addPhotoSwipeItems, getMarketingByJobId, showMarketing })(withStyles(styles, { withTheme: true })(withRouter(Home)));
